import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "BOM__BOMExactMatch",
    initialState: {
        selected_fields: {}
    },
    reducers: {
        load_all_selected_fields: {
            reducer: (state, action) => {
                state.selected_fields = action.payload.selected_fields;
            },
        },
        load_initialState: {
            reducer: (state, action) => {
                state = action.payload;
                if (action.payload.selected_fields === undefined) {
                    state.selected_fields = {};
                }
                return state;
            },
        },
        remove_all_selected_fields: {
            reducer: (state, action) => {
                state.selected_fields = {};
            },
        },
        remove_selected_field:{
            reducer: (state, action) => {
                if(state.selected_fields[action.payload.bomDetailId] !== undefined)
                {
                    delete state.selected_fields[action.payload.bomDetailId];
                }
            },
        },
        toggle_single_selected_fields: {
            reducer: (state, action) => {
                if (state.selected_fields[action.payload.bomDetailId] !== undefined) {
                    if (action.payload.forceAdd === true) {
                        delete state.selected_fields[action.payload.bomDetailId];
                        state.selected_fields[action.payload.bomDetailId] = action.payload;
                    } else {
                        delete state.selected_fields[action.payload.bomDetailId];
                    }

                } else {
                    if (action.payload.forceAdd === true) {
                        delete state.selected_fields[action.payload.bomDetailId];
                    } else {
                        state.selected_fields[action.payload.bomDetailId] = action.payload;
                    }
                    // if (state.selected_fields[action.payload.bomDetailId] === undefined) {
                    //     state.selected_fields[action.payload.bomDetailId] = action.payload;
                    // }
                }
            },
        },
    }
})
    ;

export let {
    load_all_selected_fields,
    remove_all_selected_fields,
    remove_selected_field,
    toggle_single_selected_fields,
    load_initialState
} = slice.actions;

export default slice.reducer;
